import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import '../rtl.css'
import App from './App.jsx'

// Initialize Sentry error tracking
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION || 'unknown',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,
    // Don't send errors in development
    enabled: import.meta.env.MODE !== 'development',
  });
}

// Register PWA service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
  // SW sends STALE_CHUNK when a /assets/ request returns text/html (missing chunk).
  // This fires before React even sees the error, giving us the earliest possible reload.
  navigator.serviceWorker.addEventListener('message', (e) => {
    if (e.data?.type === 'STALE_CHUNK') {
      const last = parseInt(sessionStorage.getItem('chunk_reload_at') || '0', 10);
      if (Date.now() - last > 5_000) {
        sessionStorage.setItem('chunk_reload_at', String(Date.now()));
        window.location.reload();
      }
    }
  });
}

// Fallback: vite:preloadError fires when Vite's preload helper catches a chunk failure.
// 5-second cooldown is enough to prevent reload loops while still handling stale chunks.
window.addEventListener('vite:preloadError', () => {
  const last = parseInt(sessionStorage.getItem('chunk_reload_at') || '0', 10);
  if (Date.now() - last > 5_000) {
    sessionStorage.setItem('chunk_reload_at', String(Date.now()));
    window.location.reload();
  }
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={
      <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'100vh', fontFamily:'sans-serif', gap:'12px', background:'#fafafa' }}>
        <h2 style={{ margin:0, color:'#18181b' }}>Something went wrong</h2>
        <p style={{ margin:0, color:'#71717a' }}>Please refresh the page. If the problem persists, contact support.</p>
        <button onClick={() => window.location.reload()} style={{ padding:'8px 20px', background:'#dc2626', color:'#fff', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'bold' }}>
          Refresh
        </button>
      </div>
    }>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
